/**
 * React Query Mutation Hook for sending invoice email
 * POST /api/v1/invoices/{id}/send-email
 */

import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { SendInvoiceEmailRequest, SendEmailResponse, ApiErrorResponse } from '@/types';
import { apiClient } from '@/api/client';

interface SendInvoiceEmailVariables {
  invoiceId: number;
  emailRequest: SendInvoiceEmailRequest;
}

/**
 * Send invoice via email to customer or specified recipients
 */
export const useSendInvoiceEmail = (
  options?: Omit<
    UseMutationOptions<SendEmailResponse, ApiErrorResponse, SendInvoiceEmailVariables>,
    'mutationFn'
  >
) => {
  return useMutation<SendEmailResponse, ApiErrorResponse, SendInvoiceEmailVariables>({
    mutationFn: async ({ invoiceId, emailRequest }: SendInvoiceEmailVariables) => {
      const response = await apiClient.post<SendEmailResponse>(
        `/commerce-service/api/v1/invoices/${invoiceId}/send-email`,
        emailRequest
      );
      return response.data;
    },
    ...options,
  });
};
